<template>
  <a :class="buttonClass" @click="startImport(source)" v-if="cloudsponge">
    <img :src="`/assets/icons/${icon}-icon.png`">
    {{ label }}
  </a>
</template>

<script>
import helpers from '../../helpers'

export default {
  props: {
    icon: String,
    source: String,
    label: String,
    buttonClass: [String, Object]
  },
  data () {
    return {
      cloudsponge: null
    }
  },
  methods: {
    /**
     * Open the importer
     */
    startImport (source) {
      // launch the OAuth flow
      this.cloudsponge.launch(source)
    },
    /**
     * Process the data that's received from CloudSponge
     */
    handleImport (contacts, source, owner) {
      // parse the contact data
      contacts = this.parseData(contacts)
      // emit the data
      this.emitData(source, owner, contacts)
    },
    /**
     * Format the CloudSponge data into the format that our API want it
     * @param data
     * @return {{}}
     */
    parseData (data) {
      // filter out any empty rows
      data = data.filter((contact) => {
        return contact.first_name || contact.last_name
      })
      // format the data
      return data.map((contact) => {
        return {
          firstName: contact.first_name,
          lastName: contact.last_name,
          emails: contact.email.map((email) => {
            return {
              email: email.address,
              type: email.type ? email.type.toUpperCase() : null,
              isPrimary: email.address === contact.selectedEmail()
            }
          }),
          phones: contact.phone.map((phone) => {
            return {
              number: phone.number,
              type: phone.type ? phone.type.toUpperCase() : null
            }
          }),
          addresses: (contact.address || []).map((address) => {
            return {
              line1: address.street || null,
              city: address.city || null,
              state: address.region || null,
              zipCode: address.postal_code || null,
              type: address.type ? address.type.toUpperCase() : null
            }
          }),
          occupation: contact.job_title || null,
          employer: contact.companies && contact.companies[0] ? contact.companies[0] : null
        }
      })
    },
    /**
     * Emit the imported data to the parent component
     * @param source
     * @param owner
     * @param contacts
     */
    emitData (source, owner, contacts) {
      // format the response
      const response = {
        source: source,
        sourceMeta: owner,
        contacts: contacts
      }
      // emit the response
      this.$emit('data', response)
    }
  },
  async created () {
    // inject the cloudsponge sdk and wait for it to load
    const url = 'https://api.cloudsponge.com/widget/1da5c45a75a49a272b9d46ecec9a23c65fc81bf9.js'
    await helpers.injectScriptTagAndWaitForLoad(url, () => { return window.cloudsponge })
    // set the SDK instance to the scope
    this.cloudsponge = window.cloudsponge
    // setup a listener for handling the contacts
    this.cloudsponge.init({
      inlineOauth: true,
      afterSubmitContacts: this.handleImport
    })
  }
}
</script>
